(function ($) {
  "use strict";

  var switchVertical = function (vertical, landlord_type, propertiesCount = null) {
    const subdirectory = window.location.pathname.split('/q/')[0];
    const url = `${subdirectory}/${vertical}/questionnaire/redirect_from_cms?landlord_type=${landlord_type}`;
    let location = url + window.location.search.replace(/^\?/, '&');
    if (propertiesCount) location += `&number_of_properties=${propertiesCount}`;

    window.location = location
  };

  $(function () {
    $("body.commercial_landlord #property_type_residential").on('click', function () {
      switchVertical("landlord", "residential");
    });

    $("body.landlord #landlord_type_commercial, body.landlord #landlord_type_mixed").on('click', function () {
      switchVertical("commercial_landlord", this.value);
    });
  });

}(window.jQuery));
